import { homeStyles } from './homeStyles';
import { MainContent } from '../MainContent/MainContent';
import { Navbar } from '../Navbar/Navbar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { HomeScreen } from '../HomeScreen/HomeScreen';
import { selectAccepted } from '../../store/termsAndConditions/termsAndConditionsSlice';
import { useSelector } from 'react-redux';
import { Footer } from '../Footer/Footer';

export const Home = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = homeStyles(theme, isDark);
  const acceptedTermsAndConditions = useSelector(selectAccepted);
  return (
    <Box sx={classes.container}>
      {acceptedTermsAndConditions ? (
        <>
          <Box>
            <Navbar />
            <MainContent />
          </Box>
          <Footer />
        </>
      ) : (
        <HomeScreen />
      )}
    </Box>
  );
};
